module.exports = __webpack_public_path__ + "img/anzihong.3020f2fe.png";